import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../../FirebaseConfig";
import { Bar } from "react-chartjs-2";
import { Typography } from "@mui/joy";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const colors = {
  backgroundColor: [
    "rgba(255, 99, 132, 0.3)",
    "rgba(54, 162, 235, 0.3)",
    "rgba(255, 206, 86, 0.3)",
    "rgba(75, 192, 192, 0.3)",
    "rgba(153, 102, 255, 0.3)",
    "rgba(255, 159, 64, 0.3)",
    "rgba(201, 203, 207, 0.3)",
    "rgba(128, 0, 128, 0.3)",
    "rgba(0, 128, 128, 0.3)",
    "rgba(128, 128, 0, 0.3)",
    "rgba(0, 255, 127, 0.3)",
    "rgba(255, 20, 147, 0.3)",
    "rgba(70, 130, 180, 0.3)",
    "rgba(105, 105, 105, 0.3)",
    "rgba(255, 140, 0, 0.3)",
    "rgba(102, 205, 170, 0.3)",
    "rgba(240, 128, 128, 0.3)",
    "rgba(135, 206, 235, 0.3)",
    "rgba(218, 112, 214, 0.3)",
    "rgba(0, 191, 255, 0.3)",
    "rgba(47, 79, 79, 0.3)",
    "rgba(255, 69, 0, 0.3)",
  ],
  borderColor: [
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
    "rgba(75, 192, 192, 1)",
    "rgba(153, 102, 255, 1)",
    "rgba(255, 159, 64, 1)",
    "rgba(201, 203, 207, 1)",
    "rgba(128, 0, 128, 1)",
    "rgba(0, 128, 128, 1)",
    "rgba(128, 128, 0, 1)",
    "rgba(0, 255, 127, 1)",
    "rgba(255, 20, 147, 1)",
    "rgba(70, 130, 180, 1)",
    "rgba(105, 105, 105, 1)",
    "rgba(255, 140, 0, 1)",
    "rgba(102, 205, 170, 1)",
    "rgba(240, 128, 128, 1)",
    "rgba(135, 206, 235, 1)",
    "rgba(218, 112, 214, 1)",
    "rgba(0, 191, 255, 1)",
    "rgba(47, 79, 79, 1)",
    "rgba(255, 69, 0, 1)",
  ],
};

const BarChart = ({ eventName }) => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });

  const options = {
    indexAxis: 'y', // Changed to display horizontal bars
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: { stepSize: 1 },
        title: {
          display: true,
          font: {
            weight: "bold", 
            size: 14, 
          },
          text: "Number of Submissions (Count)",
        },
      },
      y: {
        title: {
          display: true,
          font: {
            weight: "bold", 
            size: 16, 
          },
          text: "Participants",
        },
      },
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      const solveCountsRef = doc(
        db,
        `Events/${eventName}/Statistics`,
        "participantStats"
      );
      const solveCountsDoc = await getDoc(solveCountsRef);

      if (solveCountsDoc.exists()) {
        const data = solveCountsDoc.data();
        const labels = Object.keys(data);
        const values = Object.values(data);

        setChartData({
          labels,
          datasets: [
            {
              data: values,
              backgroundColor: colors.backgroundColor.slice(0, values.length),
              borderColor: colors.borderColor.slice(0, values.length),
              borderWidth: 1,
              borderRadius: 30,
            },
          ],
        });
      }
    };

    fetchData();
  }, [eventName]);

  return (
    <div
      style={{ width: "100%" }}
      className="w-full justify-center items-center"
    >
      {chartData.labels.length > 0 ? (
        <Bar options={options} data={chartData} />
      ) : (
        <div className="flex justify-center items-center h-[30vh]">
          <Typography level="h4" className="text-black-500">
            No Data Available
          </Typography>
        </div>
      )}
    </div>
  );
};

export default BarChart;